import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Field } from 'libs/forms/views/field';
import { ComponentRegistry } from 'core/index';
import { ReferenceFieldStore } from 'libs/forms/fieldStores';

import Address from 'apps/addresses/blocks/Address';

import { AddressesAppManager } from './appManager';

@observer
export class AddressChoiceField extends Field {
  static defaultStore = ReferenceFieldStore;

  disposers = [];

  dispose() {
    this.disposers.forEach(disposer => disposer());
  }

  constructor(props) {
    super(props);
    this.initManager();
  }

  componentWillUnmount() {
    this.dispose();
  }

  initManager() {
    if (this.manager) this.manager.dispose();
    this.manager = new AddressesAppManager(this, {
      fieldStore: this.props.fieldStore,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fieldStore !== this.props.fieldStore) {
      this.initManager();
    }
  }

  render() {
    // The <Form> and 'addressCards' should probably be loaded in a Modal, to avoid nested form elements
    // and improve user-experience.

    return <Address manager={this.manager} />;
  }
}

AddressChoiceField.propTypes = {
  fieldStore: PropTypes.object,
};

ComponentRegistry.add('addresses.AddressChoiceField', AddressChoiceField);
